import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, FormControl, RadioGroup,
  FormControlLabel, Radio, CircularProgress
} from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import Config from '../../ckcore/core/Config';
import { Roles, getRoleName, getRoleStatus } from '../../ckcore/core/Roles';
import User from '../../ckcore/core/User';

export default function EditStaffRoleDialog({ open, onClose, partnerId, staff }) {
  const { keycloak } = useKeycloak();

  const initialRoleValue = staff.role || 'staff';
  const [role, setRole] = useState(initialRoleValue);
  const [initialRole, setInitialRole] = useState(initialRoleValue);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const enableSelectRole = (requestRole) => {
    // can not change owner
    if (User.getEmail() === staff.email) {
      return false;
    }
    
    if (User.isOwner()) {
       return true; 
    }

    // allow change role
    if (User.getActiveRole() === Roles.ADMIN && staff.role === Roles.MANAGER && requestRole === Roles.ADMIN) {
      return true;
    }

    if (staff.role === Roles.ADMIN || requestRole === Roles.ADMIN) {
      return false;
    }

    // not enough rights
    if (User.getActiveRole() === Roles.MANAGER || User.getActiveRole() === Roles.STAFF) {
      return false;
    }

    return true;
  }
  
  useEffect(() => {
    const initVal = staff.role || 'staff';
    setRole(initVal);
    setInitialRole(initVal);
    setMessage({ type: '', text: '' });
  }, [staff]);

  const handleUpdateRole = async () => {
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const url = `${Config.getServerStaffURL()}/staff/${staff.id}`;
      const resp = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${keycloak.token}`
        },
        body: JSON.stringify({ newRole: role })
      });

      if (resp.ok) {
        setMessage({ type: 'success', text: 'Cập nhật thành công!' });
        setTimeout(onClose, 1500);
      } else {
        const data = await resp.json();
        setMessage({ type: 'error', text: data.message || 'Lỗi cập nhật' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Lỗi mạng hoặc server' });
    }
    setLoading(false);
    setInitialRole(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cập nhật vai trò</DialogTitle>
      <DialogContent dividers>
        {message.text && (
          <Typography color={message.type === 'error' ? 'error' : 'success.main'}>
            {message.text}
          </Typography>
        )}
        <Typography><strong>Họ tên:</strong> {staff.name}</Typography>
        <Typography><strong>Email:</strong> {staff.email}</Typography>

        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <RadioGroup row value={role} onChange={(e) => setRole(e.target.value)}>
            <FormControlLabel
              control={<Radio color="primary" />}
              value={Roles.ADMIN}
              label={getRoleName(Roles.ADMIN)}
              disabled={!enableSelectRole(Roles.ADMIN)}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value={Roles.MANAGER}
              label={getRoleName(Roles.MANAGER)}
              disabled={!enableSelectRole(Roles.MANAGER)}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value={Roles.STAFF}
              label={getRoleName(Roles.STAFF)}
              disabled={!enableSelectRole(Roles.STAFF)}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>Hủy</Button>
        <Button
          variant="outlined" color="warning"
          disabled={loading || role === initialRole}
          onClick={handleUpdateRole}
        >
          {loading && <CircularProgress size={16} color="inherit" />} Cập nhật
        </Button>
      </DialogActions>
    </Dialog>
  );
}
